module.exports = __webpack_public_path__ + "img/ch.10a27bf1.svg";